import { useState } from 'react'
import { toast } from 'react-toastify'
import { useSetAtom } from 'jotai/react'

import { useGlobalMethodProviderContext } from '@/providers/GlobalMethodProvider'
import { userInfoAtom } from '@/stores/services'

import useFetch, { Method } from './useFetch'
import { useToken } from './useLoginWallet'

export type UserInfo = {
  uid: string
  uname: string
  wallet: string
  photo: string
  introduce: string
  xid: string
  xname: string
  xavatar: string
}

export const useUserInfo = () => {
  const { token } = useToken()
  const setUserInfo = useSetAtom(userInfoAtom)

  const { data, ...rest } = useFetch<{ userInfo: UserInfo }>(
    token ? '/user/profile' : null,
    Method.GET,
    undefined,
    {
      onSuccess: (data) => {
        setUserInfo(data.userInfo)
      }
    }
  )

  return {
    data,
    ...rest
  }
}

export type UpdateUserInfoParams = {
  file?: File
  name: string
  introduce?: string | null
}

export const useUpdateUserInfo = (onSuccess: () => void) => {
  const { token } = useToken()
  const [params, setParams] = useState<FormData>()

  const { refreshUserInfo } = useGlobalMethodProviderContext()

  const { data, ...rest } = useFetch(
    token && params ? '/user/profile/update' : null,
    Method.POST,
    params,
    {
      onSuccess: () => {
        refreshUserInfo()
        onSuccess()
        toast.success('Update successfully')
      }
    }
  )

  return {
    data,
    setParams,
    ...rest
  }
}

//
